/**
 * Devuelve una regla que coincida con el nombre y operador pasados por parametro
 * Ejemplo de regla devuelta: {"name":"cookie","operator":"equal","values":["1"],"parameters":[{"name":"ee"}]}]}
 *
 * @param ruleName
 * @param operator
 * @param rulesList
 * @returns {null|*}
 */
const getRuleByOperator =  function (ruleName, operator, rulesList) {
    if (rulesList !== undefined) {
        let parsedRules = JSON.parse(rulesList).rules;
        for (let key in parsedRules) {
            let ruleFound = false;
            for (let prop in parsedRules[key]) {
                if (prop == 'name' && parsedRules[key][prop] == ruleName) { //rule found
                    ruleFound = true;
                }
                if (ruleFound && prop == 'operator' && parsedRules[key][prop] == operator) { //operator matches
                    return parsedRules[key];
                }
            }
        }
    }
    return null;
}

/**
 * Devuelve una regla que coincida con el nombre, operador y valor pasados por parametro
 * Ejemplo de regla devuelta: {"name":"cookie","operator":"equal","values":["1"],"parameters":[{"name":"ee"}]}]}
 *
 * @param ruleName
 * @param operator
 * @param values
 * @param rulesList
 * @returns {string|*}
 */
const getRuleByValues =  function (ruleName, operator, values, rulesList) {
    if (rulesList !== undefined) {
        let parsedRules = JSON.parse(rulesList).rules;
        for (let key in parsedRules) {
            let ruleFound = false;
            let operatorMatched = false;
            for (let prop in parsedRules[key]) {
                if (prop == 'name' && parsedRules[key][prop] == ruleName) { //rule found
                    ruleFound = true;
                }
                if (ruleFound && prop == 'operator' && parsedRules[key][prop] == operator) { //operator matches
                    operatorMatched = true;
                }
                if (ruleFound && operatorMatched && prop == 'values') { //values match
                    let valuesMatched = true;
                    for (let valueKey in values) {
                        if (values[valueKey] != parsedRules[key][prop][valueKey]) {
                            valuesMatched = false;
                        }
                    }
                    if (valuesMatched) {
                        return parsedRules[key];
                    }
                }
            }
        }
    }
    return '';
}

/**
 * Devuelve los valores de una regla
 * Ejemplo de valores devueltos: ['H', 'V']
 *
 * @param rule
 * @returns {string|*}
 */
const getValues = function (rule) {
    if (rule != null) {
        return rule['values'];
    }
    return "";
}

/**
 * Devuelve los valores del parametro expecificado de una regla
 * Ejemplo de valores devueltos: ['30200', '30220']
 *
 * @param rule
 * @param parameterName
 * @returns {string|*}
 */
const getParameterValues = function (rule, parameterName) {
    if (rule != null) {
        if (rule['parameters'] !== undefined) {
            for (let key in rule['parameters']) {
                return rule['parameters'][key][parameterName];
            }
        }
    }
    return "";
}

/**
 * Gestiona una regla (Crea/Modifica/Elimina) dentro de una lista de reglas si coincide con el nombre y operador pasados por parametro
 * Si desea eliminar una regla, reemplace los 'values/ruleValues' con 'false' o vacío
 * @param ruleName Nombre de la regla
 * @param ruleOperator Operador de la regla
 * @param ruleValues Valores de la regla
 * @param ruleParameters Parámetros de la regla
 * @param rulesList Lista de reglas
 */
const handleRuleByOperator = function (ruleName, ruleOperator, ruleValues, ruleParameters, rulesList) {
    let finalRules = [];

    // Eliminamos la regla que gestionamos (si ya existe)
    let parsedRules = JSON.parse(rulesList).rules;
    for (let key in parsedRules) {
        let addRule = true;
        let ruleFound = false;
        for (let prop in parsedRules[key]) {
            if (prop == 'name' && parsedRules[key][prop] == ruleName) {
                ruleFound = true;
            }
            if (ruleFound && prop == 'operator' && parsedRules[key][prop] == ruleOperator) {
                addRule = false;
                break;
            }
        }
        if (addRule) {
            finalRules.push(parsedRules[key]);
        }
    }

    //Añadimos la nueva regla si no tiene valores vacios o false
    let addRule = true;
    if (ruleValues.length > 0) {
        for (let key in ruleValues) {
            if (!ruleValues[key]) {
                addRule = false;
                break;
            }
        }
    } else {
        addRule = false;
    }
    if (addRule) {
        let rule = {"name":ruleName, "operator":ruleOperator, "values":ruleValues};
        if (ruleParameters) {
            rule['parameters'] = ruleParameters;
        }
        finalRules.push(rule);
    }

    return JSON.stringify({"rules" : finalRules});
}

/**
 * Gestiona una regla (Crea/Modifica/Elimina) dentro de una lista de reglas si coincide con el nombre, operador y parametros pasados por parametro
 * @param ruleName Nombre de la regla
 * @param ruleOperator Operador de la regla
 * @param ruleValues Valores de la regla
 * @param ruleParameters Parámetros de la regla
 * @param rulesList Lista de reglas
 */
const handleRuleByParameters = function (ruleName, ruleOperator, ruleValues, ruleParameters, rulesList) {
    let finalRules = [];

    // Eliminamos la regla que gestionamos (si ya existe)
    let parsedRules = JSON.parse(rulesList).rules;
    for (let key in parsedRules) {
        let addRule = true;
        let ruleFound = false;
        let operatorMatched = false;
        for (let prop in parsedRules[key]) {
            if (prop == 'name' && parsedRules[key][prop] == ruleName) { //rule found
                ruleFound = true;
            }
            if (ruleFound && prop == 'operator' && parsedRules[key][prop] == ruleOperator) { //operator matches
                operatorMatched = true;
            }
            if (ruleFound && operatorMatched && prop == 'values') { //values match
                let valuesMatched = true;
                for (let valueKey in ruleValues) {
                    if (ruleValues[valueKey] != parsedRules[key][prop][valueKey]) {
                        valuesMatched = false;
                    }
                }
                if (valuesMatched) {
                    addRule = false;
                }
            }
        }
        if (addRule) {
            finalRules.push(parsedRules[key]);
        }
    }

    //Añadimos la nueva regla si no tiene parametros vacios o false
    let addRule = true;
    if (ruleParameters.length > 0) {
        for (let key in ruleParameters) {
            if (!ruleParameters[key] || ruleParameters[key] == '') {
                addRule = false;
                break;
            } else if (typeof ruleParameters[key] === "object") {
                for (let property in ruleParameters[key]) {
                    if (!ruleParameters[key][property] || ruleParameters[key][property] == '') {
                        addRule = false;
                    }
                }
            }
        }
    } else {
        addRule = false;
    }
    if (addRule) {
        let rule = {"name":ruleName, "operator":ruleOperator, "values":ruleValues};
        if (ruleParameters) {
            rule['parameters'] = ruleParameters;
        }
        finalRules.push(rule);
    }

    return JSON.stringify({"rules" : finalRules});
}

export default {
    getValues,
    getParameterValues,
    getRuleByOperator,
    getRuleByValues,
    handleRuleByOperator,
    handleRuleByParameters
};